import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.8346 13H2.16797"
        stroke="#DF692B"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.90547 5.53551L2.16797 12.9997V19.4997C2.16797 20.0743 2.39624 20.6254 2.80257 21.0317C3.2089 21.4381 3.76 21.6663 4.33464 21.6663H21.668C22.2426 21.6663 22.7937 21.4381 23.2 21.0317C23.6064 20.6254 23.8346 20.0743 23.8346 19.4997V12.9997L20.0971 5.53551C19.9178 5.17453 19.6412 4.87074 19.2987 4.65831C18.9561 4.44588 18.5611 4.33322 18.158 4.33301H7.84464C7.44154 4.33322 7.04651 4.44588 6.70393 4.65831C6.36136 4.87074 6.08484 5.17453 5.90547 5.53551V5.53551Z"
        stroke="#DF692B"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 17.333H6.51"
        stroke="#DF692B"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.832 17.333H10.842"
        stroke="#DF692B"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default Icon;
